import {
  LEGACY_F29_MODULE_ID,
  resolveStaffModuleAccess,
} from './staffModulePermissions';

export const FORMULARIO_29_MODULE_ID = 'formulario_29';
export const CONSOLIDADO_F29_MODULE_ID = 'consolidado_f29';

const F29_LEGACY = [LEGACY_F29_MODULE_ID];

export function resolveFormulario29Access(userPerms, companyPerms, userCompanyPerms, roles) {
  return resolveStaffModuleAccess(
    FORMULARIO_29_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
    F29_LEGACY,
  );
}

export function resolveConsolidadoF29Access(userPerms, companyPerms, userCompanyPerms, roles) {
  return resolveStaffModuleAccess(
    CONSOLIDADO_F29_MODULE_ID,
    userPerms,
    companyPerms,
    userCompanyPerms,
    roles,
    F29_LEGACY,
  );
}

export function resolveF29ModuleAccess(moduleId, userPerms, companyPerms, userCompanyPerms, roles) {
  if (moduleId === FORMULARIO_29_MODULE_ID) {
    return resolveFormulario29Access(userPerms, companyPerms, userCompanyPerms, roles);
  }
  if (moduleId === CONSOLIDADO_F29_MODULE_ID) {
    return resolveConsolidadoF29Access(userPerms, companyPerms, userCompanyPerms, roles);
  }
  return false;
}
